import { 
  PaymentMethodType, 
  OnlinePaymentMode, 
  UPIProvider, 
  CurrencyOption,
  PaymentFormValues 
} from './collectPayment.types';

export const PAYMENT_METHODS: Array<{ value: PaymentMethodType; label: string }> = [
  { value: 'cash', label: 'Cash Payment' },
  { value: 'online', label: 'Online' },
  { value: 'card', label: 'Card Payment' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'upi', label: 'UPI' },
  { value: 'wallet', label: 'Wallet' },
];

export const ONLINE_PAYMENT_MODES: Array<{ value: OnlinePaymentMode; label: string }> = [
  { value: 'NEFT', label: 'NEFT' },
  { value: 'RTGS', label: 'RTGS' },
  { value: 'IMPS', label: 'IMPS' },
];

export const UPI_PROVIDERS: Array<{ 
  value: UPIProvider; 
  label: string; 
  icon: string;
  color: string;
}> = [
  { value: 'phonepe', label: 'Phone Pe', icon: 'https://upload.wikimedia.org/wikipedia/commons/7/71/PhonePe_Logo.svg', color: '#5f259f' },
  { value: 'googlepay', label: 'Google Pay', icon: 'https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg', color: '#4285f4' },
  { value: 'paytm', label: 'PayTM', icon: 'https://upload.wikimedia.org/wikipedia/commons/2/24/Paytm_Logo_%28standalone%29.svg', color: '#00b9f5' },
];

export const CURRENCIES: CurrencyOption[] = [
  { label: 'Indian Rupee (INR)', value: 'INR', symbol: '₹' },
  { label: 'United States Dollar (USD)', value: 'USD', symbol: '$' },
  { label: 'Euro (EUR)', value: 'EUR', symbol: '€' },
  { label: 'British Pound (GBP)', value: 'GBP', symbol: '£' },
  { label: 'UAE Dirham (AED)', value: 'AED', symbol: 'د.إ' },
];

export const INITIAL_PAYMENT_VALUES: PaymentFormValues = {
  paymentMode: 'settle',
  paymentMethod: 'cash',
  cash: {
    amount: 0,
    notes: '',
  },
  online: {
    amount: 0,
    paymentMode: '',
    transactionNumber: '',
    notes: '',
  },
  card: {
    amount: 0,
    transactionNumber: '',
    notes: '',
  },
  cheque: {
    amount: 0,
    chequeNumber: '',
    date: '',
    bankName: '',
    notes: '',
  },
  upi: {
    amount: 0,
    provider: '',
    transactionNumber: '',
  },
  wallet: {
    amount: 0,
    advances: [],
    notes: '',
  },
};

export const WALLET_TABLE_COLUMNS = [
  { id: 'date', label: 'Date', width: '12%' },
  { id: 'advanceAgainst', label: 'Advance Against', width: '22%' },
  { id: 'total', label: 'Total', width: '14%' },
  { id: 'used', label: 'Used', width: '14%' },
  { id: 'balance', label: 'Balance', width: '14%' },
  { id: 'consume', label: 'Consume', width: '24%' },
];
